import {REBRAND_BASE_URL} from "../../services/config";

type TViewProductLinkPayload = {
  username: string;
  slug: string;
  tinyUrl?: string;
  productId: string | number;
  windowNav?: boolean;
};
type TViewStoreServiceLinkPayload = {
  username: string;
  slug: string;
  tinyUrl?: string;
  serviceId: string | number;
  windowNav?: boolean;
};
type TViewSubscriptionLinkPayload = {
  username: string;
  slug: string;
  tinyUrl?: string;
  subscriptionId: string | number;
  windowNav?: boolean;
};
type TProductSuccessLinkPayload = {
  username: string;
  slug: string;
  productId: string | number;
  windowNav?: boolean;
};

export function handleProductLink({
  productId,
  slug,
  username,
  tinyUrl,
  windowNav,
}: TViewProductLinkPayload) {
  // const baseLink = `/${username}/products/details?slug=${slug}&productId=${productId}`;

  // if (windowNav) {
  const link = tinyUrl
    ? `${REBRAND_BASE_URL}/${username}/${tinyUrl}`
    : `${REBRAND_BASE_URL}/${username}/product/${slug}?id=${productId}`;
  return link;
  //   } else {
  //     return baseLink;
  //   }
}
export function handleStoreServiceLink({
  serviceId,
  slug,
  username,
  tinyUrl,
  windowNav,
}: TViewStoreServiceLinkPayload) {
  // const baseLink = `/${username}/products/details?slug=${slug}&productId=${productId}`;

  // if (windowNav) {
  const link = tinyUrl
    ? `${REBRAND_BASE_URL}/${username}/${tinyUrl}`
    : `${REBRAND_BASE_URL}/${username}/store/services/${slug}?id=${serviceId}`;
  return link;
  //   } else {
  //     return baseLink;
  //   }
}
export function handleSubscriptionLink({
  subscriptionId,
  slug,
  username,
  tinyUrl,
  windowNav,
}: TViewSubscriptionLinkPayload) {
  const link = tinyUrl
    ? `${REBRAND_BASE_URL}/${username}/${tinyUrl}`
    : `${REBRAND_BASE_URL}/${username}/store/subscriptions/${slug}?id=${subscriptionId}`;
  return link;
}
export function handleTwitterLink({
  textContent,
  username,
}: {
  textContent: string;
  username: string;
}) {
  return `https://twitter.com/intent/tweet?text=${textContent}&url=${REBRAND_BASE_URL}/${username}&hashtags=coachli,useCoachli`;
}
export function handleFacebookLink({username}: {username: string}) {
  return `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcoachli.co%2F${username}&amp`;
}
export function handleMailLink({subject, body}: {subject: string; body: string}) {
  return `mailto:?subject=${subject}&amp;body=${body}`;
}
export function handleProductSuccessBookingLink({
  productId,
  slug,
  username,
  windowNav,
}: TProductSuccessLinkPayload) {
  const baseLink = `/${username}/product/slug=${slug}/success?id=${productId}`;

  if (windowNav) {
    const link = `${REBRAND_BASE_URL}${baseLink}`;
    return link;
  } else {
    return baseLink;
  }
}
